export default [
    {
        value: 1,
        text: 'A',
        valor: 'Alfa',
    },
    {
        value: 2,
        text: 'B',
        valor: 'Bravo',
    },
    {
        value: 3,
        text: 'C',
        valor: 'Charlie',
    },
    {
        value: 4,
        text: 'D',
        valor: 'Delta',
    },
    {
        value: 5,
        text: 'E',
        valor: 'Echo',
    },
    {
        value: 6,
        text: 'F',
        valor: 'Foxtrot',
    },
    {
        value: 7,
        text: 'G',
        valor: 'Golf',
    },
    {
        value: 8,
        text: 'H',
        valor: 'Hotel',
    },
    {
        value: 9,
        text: 'I',
        valor: 'India',
    },
    {
        value: 10,
        text: 'J',
        valor: 'Juliet',
    },
    {
        value: 11,
        text: 'K',
        valor: 'Kilo',
    },
    {
        value: 12,
        text: 'L',
        valor: 'Lima',
    },
    {
        value: 13,
        text: 'M',
        valor: 'Mike',
    },
    {
        value: 14,
        text: 'N',
        valor: 'November',
    },
    {
        value: 15,
        text: 'O',
        valor: 'Oscar',
    },
    {
        value: 16,
        text: 'P',
        valor: 'Papa',
    },
    {
        value: 17,
        text: 'Q',
        valor: 'Quebec',
    },
    {
        value: 18,
        text: 'R',
        valor: 'Romeo',
    },
    {
        value: 19,
        text: 'S',
        valor: 'Sierra',
    },
    {
        value: 20,
        text: 'T',
        valor: 'Tango',
    },
    {
        value: 21,
        text: 'U',
        valor: 'Uniform',
    },
    {
        value: 22,
        text: 'V',
        valor: 'Victor',
    },
    {
        value: 23,
        text: 'W',
        valor: 'Whiskey',
    },
    {
        value: 24,
        text: 'X',
        valor: 'X-ray',
    },
    {
        value: 25,
        text: 'Y',
        valor: 'Yankee',
    },
    {
        value: 26,
        text: 'Z',
        valor: 'Zulu',
    },
];
